import { createFileRoute } from '@tanstack/react-router'

import { NotificationsPage } from '@/features/account/pages/notifications-page'

/** G4 — full-page notifications feed. */
export const Route = createFileRoute('/_ws/w/$workspaceId/notifications')({
  component: NotificationsPage,
})
